import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	Button,
	Flex,
	Text,
	Box,
	Spinner,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { useFetchItemsQuery } from 'api/apiSlice';
import { getCurrentInterviewRound } from 'views/admin/hiring/helpers';
import { useMemo } from 'react';
import useUserSession from 'hooks/useUserSession';

const NotificationView = ({ title, item, type, isOpen, onClose }) => {
	const navigate = useNavigate();

	const { user } = useUserSession();

	const {
		data: interview,
		isLoading,
		error,
	} = useFetchItemsQuery(
		{
			path: `/interviews/${item?.interview_id}`,
		},
		{
			skip: !item?.interview_id,
			refetchOnMountOrArgChange: true,
		},
	);

	const currentRound = getCurrentInterviewRound(interview?.doc);

	const isInterviewerSubmittedPoints = useMemo(() => {
		const points = currentRound?.evaluations?.find(
			(item) => item.interviewer?._id === user?._id,
		);
		return points?.status ?? false;
	}, [currentRound?.evaluations, user?._id]);

	const isInterviewCancel =
		isInterviewerSubmittedPoints ||
		interview?.doc?.status === 'end' ||
		interview?.doc?.status === 'canceled' ||
		(interview?.doc?.pendingEvaluations === 0 &&
			!interview?.doc?.isMultiRound) ||
		interview?.doc?.nextRound?.pendingEvaluations === 0 ||
		error?.status === 404;

	const handleJoinInterview = () => {
		// navigate(`/hiring/interview/${item.interview_id}`);
		navigate(`/hiring/interview/${item.metadata?.interviewId}`);
		// window.location.href = `/hiring/interview/${item.interview_id}?phase=evaluation-points`;
		onClose();
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size='2xl'
			motionPreset='slideInBottom'
			isCentered
		>
			<ModalOverlay backdropFilter='blur(8px)' bg='bg.overlay' />
			<ModalContent
				bg='bg.surface'
				borderWidth='1px'
				borderColor='border.gold'
				borderRadius='2xl'
				boxShadow='deep'
				mx={3}
			>
				<ModalHeader color='text.heading'>{title}</ModalHeader>
				<ModalBody>
					<Flex direction='column' gap={4}>
						{/* Notification Message */}
						<Box
							bg='bg.elevated'
							borderWidth='1px'
							borderColor='border.default'
							maxH='30vh'
							overflowY='auto'
							p={4}
							rounded='lg'
						>
							<Text
								fontSize='md'
								color='text.body'
								wordBreak='break-word'
								whiteSpace='pre-wrap'
							>
								{item.message}
							</Text>
						</Box>
						{/* Created At */}
						<Text fontSize='sm' color='text.muted'>
							{format(new Date(item.createdAt), 'MMM d, yyyy h:mm a')}
						</Text>
					</Flex>
				</ModalBody>

				<ModalFooter>
					{isLoading ? (
						<Box px='2'>
							<Spinner />
						</Box>
					) : isInterviewCancel ? (
						<Text fontSize='md' mx='4' color='info'>
							This invitaion is expired
						</Text>
					) : (
						!isInterviewCancel &&
						type === 'invite' && (
							<Button
								onClick={handleJoinInterview}
								fontSize='md'
								fontWeight='semibold'
								// softGray.100 on green.400 was 2.4:1 in both modes. White
								// clears AA on the deeper green.600 fill (4.6:1), and the
								// hover/active steps only darken from there.
								color='white'
								bg='green.600'
								_hover={{ bg: 'green.700', shadow: 'sm' }}
								_active={{ bg: 'green.700' }}
								transition='0.2 s all'
								width='fit-content'
								py={2}
								px={4}
								mr={2}
								rounded='md'
							>
								Join Interview
							</Button>
						)
					)}
					<Button onClick={onClose} colorScheme='gray' rounded='md'>
						Close
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default NotificationView;
